// extracted by mini-css-extract-plugin
export default {"statusSelect":"style_statusSelect__X6gD3","statusSelectNonActive":"style_statusSelectNonActive__ICNp6","statusSelectActive":"style_statusSelectActive__z3MEh"};